import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { RevealSection } from "../motion/RevealSection";
import { buildWhatsAppLink } from "../../lib/whatsapp";
import { trackWhatsAppClickConversion } from "../../lib/gtag";
import { resolveMediaUrl } from "../../lib/api";
import { SERVICE_PAGES } from "../../data/servicePages";

export const Services = ({ content, onQuoteClick }) => {
  const services = content?.services || [];
  const number = content?.whatsapp_number;

  return (
    <section id="servicios" className="relative bg-black py-24 md:py-36 px-6 md:px-16">
      <RevealSection>
        <span className="text-twp-gold text-xs uppercase tracking-[0.35em]">02 — Servicios</span>
        <h2 className="font-serif-display text-4xl md:text-6xl text-white mt-4 mb-16 max-w-2xl">
          Historias que merecen ser contadas con elegancia
        </h2>
      </RevealSection>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {services.map((s, idx) => {
          const detailPage = SERVICE_PAGES.find((p) => p.serviceKey === s.key);
          return (
          <RevealSection
            key={s.key}
            delay={idx * 0.08}
            className={`group relative overflow-hidden border border-white/10 ${idx === 0 ? "md:col-span-2 md:row-span-2" : ""}`}
          >
            <div data-testid={`service-card-${s.key}`} className="relative h-[380px] md:h-full min-h-[320px] w-full">
              <img
                src={resolveMediaUrl(s.image)}
                alt={s.label}
                className="absolute inset-0 h-full w-full object-cover brightness-[0.55] group-hover:brightness-75 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

              <div className="relative z-10 flex h-full flex-col justify-end p-6 md:p-8">
                <h3 className="font-serif-display text-2xl md:text-3xl text-white mb-2">{s.label}</h3>
                <p className="text-white/70 text-sm mb-5 max-w-sm">{s.description}</p>
                <div className="flex flex-wrap gap-3">
                  <button
                    data-testid={`service-quote-button-${s.key}`}
                    onClick={() => onQuoteClick(s.key)}
                    className="px-5 py-2.5 bg-twp-gold text-black text-xs uppercase tracking-[0.15em] font-semibold hover:bg-white transition-colors"
                  >
                    Cotizar
                  </button>
                  {detailPage && (
                    <Link
                      to={detailPage.slug}
                      data-testid={`service-details-button-${s.key}`}
                      className="inline-flex items-center gap-1.5 px-5 py-2.5 border border-white/30 text-white text-xs uppercase tracking-[0.15em] font-semibold hover:border-twp-gold hover:text-twp-gold transition-colors"
                    >
                      Ver detalles <ArrowUpRight size={14} />
                    </Link>
                  )}
                  {number && (
                    <a
                      data-testid={`service-whatsapp-button-${s.key}`}
                      href={buildWhatsAppLink(number, `Hola, me interesa cotizar el servicio de ${s.label}.`)}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={trackWhatsAppClickConversion}
                      className="px-5 py-2.5 border border-white/30 text-white text-xs uppercase tracking-[0.15em] font-semibold hover:border-twp-gold hover:text-twp-gold transition-colors"
                    >
                      WhatsApp
                    </a>
                  )}
                </div>
              </div>
            </div>
          </RevealSection>
          );
        })}
      </div>
    </section>
  );
};
